import { ThemeContext, withTheme } from '@emotion/react';
import { useContext } from 'react';
export { withTheme };
export function useTheme() {
    return useContext(ThemeContext);
}
